import type { EWalletType, IMessage } from '@dev-fast/types';

import type { IDoubleTripleJackpotStatus } from '../../types';
import { createTipleJackpotChatMessage } from './create-triple-jackpot-chat-message';

export const getJackpotStatusAndSendMessageToChatAdapter = (response: IDoubleTripleJackpotStatus, walletType: EWalletType): IMessage => {
  const message = createTipleJackpotChatMessage({
    timestamp: new Date().toISOString(),
    winnersCount: 0,
    amount: +(response.amount ?? 0),
    sequence: response.greenSequence?.length ?? 0,
    walletType: walletType,
  });
  return message;
};
